<template>
  <div
    class="detail-layout-action-links"
    :class="{ 'has-multiple-links': hasMultipleLinks }"
  >
    <a
      v-for="(link, i) in linksMapped"
      :key="i"
      class="button is-primary is-spaced"
      :class="['is-' + link.type, link.classes || '']"
      :href="link.url"
      :target="link.target"
      @click="onClick(link, $event)"
    >
      <span>{{ link.title }}</span>
      <SpriteSymbol name="chevron-right" />
    </a>
  </div>
</template>

<script lang="ts" setup>
import type { ActionLink } from '..'

const props = withDefaults(
  defineProps<{
    links?: ActionLink[]
  }>(),
  {
    links: () => [],
  },
)

const router = useRouter()
const { trackEvent } = useAnalytics()

const getLinkType = (url = ''): 'external' | 'internal' => {
  if (url.startsWith('http')) {
    return 'external'
  }
  return 'internal'
}

const linksMapped = computed(() => {
  return props.links.map((v) => {
    return {
      ...v,
      type: getLinkType(v.url),
    }
  })
})

const hasMultipleLinks = computed(() => props.links.length > 1)

const onClick = (link: ActionLink, e: MouseEvent) => {
  if (link.event) {
    trackEvent(link.event)
  }
  if (link.type === 'internal') {
    e.preventDefault()
    router.push(link.url)
  }
}
</script>

<style>
@reference '~/assets/css/tailwind.css';
.button.is-external {
  .icon {
    transform: rotate(-45deg);
  }
}
.detail-layout-action-links {
  @apply grid;
  grid-gap: 0.5rem;
  grid-template-columns: 1fr;
  @variant belowTablet {
    &.has-multiple-links {
      grid-template-columns: 1fr 1fr;
      .button {
        @apply text-size-7;
      }
    }
    &:nth-child(3) {
      .button {
        grid-column: 1 / 3;
      }
    }
  }
  .button {
    @apply w-full;
  }
  @apply belowTablet:grid;
  @variant belowTablet {
    grid-gap: 0.5rem;
  }
}
</style>
